import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext } from 'react';
import IconButton from './NavBar/IconButton';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import defaultLocale from '@/locale';
const ThemeAndLangSelector = () => {
  const {
    lang,
    setLang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  const t = useLocale();
  const handleLangChange = value => {
    setLang(value);
    const nextLang = defaultLocale[value];
    _Message.info(`${nextLang['message.lang.tips']}${value}`);
  };
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  // 自定义语言按钮样式
  const renderLanguageButton = () => {
    return /*#__PURE__*/React.createElement(_Button, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null),
      shape: "circle",
      type: "secondary",
      style: {
        border: '1px solid var(--color-border-2)',
        fontSize: '16px',
        transition: 'all 0.2s'
      },
      className: "theme-lang-button"
    });
  };

  // 自定义主题按钮样式
  const renderThemeButton = () => {
    return /*#__PURE__*/React.createElement(_Button, {
      icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
      shape: "circle",
      type: "secondary",
      style: {
        border: '1px solid var(--color-border-2)',
        fontSize: '16px',
        transition: 'all 0.2s'
      },
      className: "theme-lang-button",
      onClick: toggleTheme
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      top: '20px',
      right: '60px',
      display: 'flex',
      gap: '10px',
      zIndex: 1000
    }
  }, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];
      _Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  }), /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, renderThemeButton()));
};
export default ThemeAndLangSelector;